import BaseAPIRepository, { BaseAPIResponse } from 'api/base';
import { AxiosResponse } from 'axios';
import { BASE_URL } from 'const';
import { FERequestErrorsHandler } from 'utils';
import { OrdersValidateRequestV4 } from '.';

import { OrdersValidateResponseV4 } from '.';

const ordersRepositoryV4 = {
  ordersValidate: (
    request: OrdersValidateRequestV4.Request,
    signal?: AbortSignal,
  ) =>
    new Promise<OrdersValidateResponseV4.Response>(async (resolve, reject) => {
      try {
        let url = `${BASE_URL}/api/v4/orders/validate`;
        let result: AxiosResponse<
          BaseAPIResponse<OrdersValidateResponseV4.Response>
        > = await BaseAPIRepository.post<
          BaseAPIResponse<OrdersValidateResponseV4.Response>
        >(url, request, { signal });
        const dishesList = result.data.result.dishes.map((dish) => {
          if (!dish.problem) return {
            count: dish.product.quantity,
            pricePerItem: dish.product.price.price,
            product: {
              ids: {
                sushiveslaID: dish.product.base.uuid,
              },
            },
          }
        })
        const constructorsList = result.data.result.constructors.map((constructor) => {

          if (!constructor.problem) return {
            count: constructor.product.quantity,
            pricePerItem: constructor.product.price.price,
            product: {
              ids: {
                sushiveslaID: constructor.product.base.uuid,
              },
            },
          }
        })
        //@ts-expect-error
        window.mindbox("async", {
          operation: "SetKorzinaItemList",
          data: {
            productList: [...dishesList, ...constructorsList].filter(item => item !== undefined)
          }
        });
        resolve(result.data.result);
      } catch (error: any) {
        FERequestErrorsHandler(error, reject);
      }
    }),

  notSecureOrdersValidate: (
    request: OrdersValidateRequestV4.Request,
    signal?: AbortSignal,
  ) =>
    new Promise<OrdersValidateResponseV4.Response>(async (resolve, reject) => {
      try {
        let url = `${BASE_URL}/not-secure/api/v4/orders/validate`;
        let result: AxiosResponse<
          BaseAPIResponse<OrdersValidateResponseV4.Response>
        > = await BaseAPIRepository.post<
          BaseAPIResponse<OrdersValidateResponseV4.Response>
        >(url, request, { signal });
        const dishesList = result.data.result.dishes.map((dish) => {
          if (!dish.problem) return {
            count: dish.product.quantity,
            pricePerItem: dish.product.price.price,
            product: {
              ids: {
                sushiveslaID: dish.product.base.uuid,
              },
            },
          }
        })
        const constructorsList = result.data.result.constructors.map((constructor) => {

          if (!constructor.problem) return {
            count: constructor.product.quantity,
            pricePerItem: constructor.product.price.price,
            product: {
              ids: {
                sushiveslaID: constructor.product.base.uuid,
              },
            },
          }
        })
        //@ts-expect-error
        window.mindbox("async", {
          operation: "SetKorzinaItemList",
          data: {
            productList: [...dishesList, ...constructorsList].filter(item => item !== undefined)
          }
        });
        resolve(result.data.result);
      } catch (error: any) {
        FERequestErrorsHandler(error, reject);
      }
    }),
};

export default ordersRepositoryV4;
